import Layout from "@/components/Layout";
import CustomerServiceCTA from "@/components/CustomerServiceCTA";
import { useLive } from "@/lib/serviceInfo";
import { Clock, MapPin, Phone, Mail } from "lucide-react";

export default function Kontakt() {
  const live = useLive();
  const findUsImg = "https://static.prod-images.emergentagent.com/jobs/ac17586a-8f5d-4571-afc7-c7fa9192efaa/images/ab5bd41bcbd827fee52d5d9c217feb9a9285399560f445d7858e8c754e06b4a7.jpeg";
  return (
    <Layout>
      <section className="bg-[#3D2314] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 font-display">Kontakt og besøk</h1>
          <p className="text-white/80 max-w-2xl mx-auto">Ta gjerne kontakt, eller stikk innom verkstedet i åpningstiden.</p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[#3D2314] mb-6 text-center font-display">Slik finner du oss</h2>
          <div className="rounded-2xl overflow-hidden shadow-lg border border-[#D4A574]/20">
            <img src={findUsImg} alt="Slik finner du Bergen Kaffemaskin- og Teknikk Service – Birkeveien 2, Bergen" className="w-full h-auto" data-testid="find-us-image" />
          </div>
          <p className="text-center text-sm text-[#1A1A1A]/60 mt-4">Inngang og parkering rett foran døren. Vi deler lokaler med Skredder Syatelier – de kan ta imot eller utlevere utstyr dersom mekanikeren ikke er til stede.</p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="space-y-6">
            {[
              { icon: MapPin, title: "Adresse", lines: ["Birkeveien 2, 5093 Bergen"] },
              { icon: Clock, title: "Åpningstider", lines: [`Mandag–Fredag: ${live.hoursWeekday}`, `Lørdag–Søndag: ${live.hoursWeekend}`] },
            ].map((c) => (
              <div key={c.title} className="flex items-start gap-4">
                <div className="shrink-0 w-10 h-10 rounded-lg bg-[#D4A574]/15 flex items-center justify-center"><c.icon className="h-5 w-5 text-[#3D2314]" /></div>
                <div><h3 className="font-semibold text-[#3D2314]">{c.title}</h3>{c.lines.map((l) => <p key={l} className="text-sm text-[#1A1A1A]/70">{l}</p>)}</div>
              </div>
            ))}
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-10 h-10 rounded-lg bg-[#D4A574]/15 flex items-center justify-center"><Phone className="h-5 w-5 text-[#3D2314]" /></div>
              <div><h3 className="font-semibold text-[#3D2314]">Telefon</h3><a href="tel:+4790232206" className="text-sm text-[#D4A574] hover:underline font-medium">90 23 22 06</a></div>
            </div>
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-10 h-10 rounded-lg bg-[#D4A574]/15 flex items-center justify-center"><Mail className="h-5 w-5 text-[#3D2314]" /></div>
              <div><h3 className="font-semibold text-[#3D2314]">E-post</h3><a href="mailto:info@bergenkaffeogteknikk.no" className="text-sm text-[#D4A574] hover:underline font-medium">info@bergenkaffeogteknikk.no</a></div>
            </div>
            <div className="bg-white rounded-xl p-5 border border-[#D4A574]/20">
              <h4 className="font-semibold text-[#3D2314] mb-2">Kollektivtransport</h4>
              <ul className="text-sm text-[#1A1A1A]/70 space-y-1">{["Buss 5", "Buss 6", "Buss 20", "Buss 16E", "Bybane linje 1"].map((b) => <li key={b}>• {b}</li>)}</ul>
            </div>
          </div>
          <div className="rounded-xl overflow-hidden border border-[#D4A574]/20 min-h-[420px]">
            <iframe title="Kart" width="100%" height="100%" style={{ border: 0, minHeight: 420 }} loading="lazy" src="https://www.google.com/maps?q=Birkeveien+2,+5093+Bergen&output=embed" />
          </div>
        </div>
      </section>

      <CustomerServiceCTA dark />
    </Layout>
  );
}
